class SoundManager {
	
	play( id ) {
		const audio = new Audio(`./audio/${id}.mp3`)
		audio.volume = 0.5;
		audio.play();
		return audio;
	}
	
}

export default new SoundManager();
